/* eslint-disable react/prop-types */
import React from 'react';
import styles from '../styles/Dashboard.module.css';

export function Swatch({ color, isTrack }) {
    return (
        <span
            className={isTrack ? `${styles.swatch} ${styles.swatchTrack}` : styles.swatch}
            style={{ background: color }}
        />
    );
}

export function Meter({ value, total, color, label }) {
    const width = total ? `${Math.max((value / total) * 100, 0)}%` : '0%';
    return (
        <span className={styles.meter} role="img" aria-label={label}>
            <span className={styles.meterFill} style={{ width, background: color }} />
        </span>
    );
}
